/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiUrl } from '../common/constants';
import { RefreshTokenEndpoint } from '../common/endpoints';

class RequestManager {
  private activeRequests: Map<string, Promise<any>> = new Map();
  async request<T>(key: string, requestFn: () => Promise<T>): Promise<T> {
    const existingRequest = this.activeRequests.get(key);
    if (existingRequest) {
      return existingRequest;
    }

    const requestPromise = requestFn()
      .then((result) => {
        this.activeRequests.delete(key);
        return result;
      })
      .catch((error) => {
        this.activeRequests.delete(key);
        throw error;
      });

    this.activeRequests.set(key, requestPromise);

    return requestPromise;
  }

  clear(): void {
    this.activeRequests.clear();
  }

  getKey(endpoint: string, body?: string): string {
    return `${endpoint}${JSON.stringify(body)}`;
  }
}

const requestManager = new RequestManager();


export default requestManager

export const refreshTokenRequest = async (token: string) => {
  const body = JSON.stringify({
    RefreshToken: token,
  })
  const key = requestManager.getKey(RefreshTokenEndpoint, body);

  return requestManager.request<{ ok: boolean, status: number, data: any }>(key, () => fetch(`${apiUrl}${RefreshTokenEndpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body,
  }).then(async res => {
    if (res.ok) {
      const data = await res.json();
      return {
        ok: true,
        status: res.status,
        data
      }
    }
    return {
      ok: false,
      status: res.status,
      data: null
    }
  }));
};